import { ForgeOption, ForgeSelect } from '@tylertech/forge-react';
import './MobileNav.css';

export default function MobileNav({ routes, activePath }) {
  // Determine if a route path matches the active path
  const isRouteActive = (routePath, currentPath) => {
    return currentPath?.startsWith(routePath);
  };

  // Get current section with children for subroute selector
  const getCurrentSectionRoute = () => {
    return routes.find(route => route.children && isRouteActive(route.path, activePath));
  };

  // Handle subroute selection from dropdown
  const handleSubrouteChange = event => {
    const selectedPath = event.target.value;
    const currentSection = getCurrentSectionRoute();
    const selectedRoute = currentSection?.children.find(r => r.path === selectedPath);
    if (selectedRoute) {
      window.location.hash = selectedRoute.href;
    }
  };

  const currentSection = getCurrentSectionRoute();
  const subroutes = currentSection?.children || [];

  if (subroutes.length === 0) return null;

  return (
    <nav aria-label={currentSection.label} className="mobile-subroute-select mx-6 mt-6">
      <ForgeSelect
        value={activePath}
        label={currentSection.label}
        density="large"
        support-text-inset="start"
        aria-describedby="subroute-helper-text"
        on-change={handleSubrouteChange}>
        {subroutes.map(subroute => (
          <ForgeOption key={subroute.key} value={subroute.path}>
            {subroute.label}
          </ForgeOption>
        ))}
        <span slot="helper-text" id="subroute-helper-text" className="forge-color--text-medium">
          Go to another page in {currentSection.label}
        </span>
      </ForgeSelect>
    </nav>
  );
}
